<a
  appHrefNone
  [ngClass]="{'icon-v2 explore': isLoggedIn || isRestaurant}"
  class="w-31px"
  (click)="goToExplore()"
></a>
